// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__fdK3K","tab":"Tabs_tab__12dxX","tabActive":"Tabs_tabActive__1EnRf"};